var baseURL = "";
export const environment = {
  production: false,
  name: 'staging',

  moyassar: {
    publishableKey: 'pk_test_UD2aikfikR8nXZhcynGrBjDZ63dw3Lpcvb9Fwtpi'
  },

  tenantsMapper: {
    "default": "asbar",
    "localhost": "asbar",


  },
  tenantConfigs: {
    "asbar": {
      "primaryColor": "#34322F",
      "lightPrimaryColor": "#F1EFEE",
      "mediumPrimaryColor": "#C3BAB6",
      "secondaryColor": "#E1EEE9",
      "successColor": "#039855",
      "errorColor": "#EE2C24",
      "warningColor": "#FF9800",
      "infoColor": "#2196F3",
      "coloredLogoUrl": "assets/images/asbar/logo.svg",
      "whiteLogoUrl": "assets/images/asbar/logo-white.svg",
      "sidePageImageUrl": "assets/images/asbar/page-side-img.svg",
      "defaultOpportunityImageUrl": "assets/images/asbar/opportunity-img.png",
      "homeMobileAppSplashImageUrl": "assets/images/asbar/mobile-app-splash.png",
      "tenantId": "asbar",
      "tenantName": "Asbar",
      "apisBaseUrl": "https://gateway.asbar.uk",
      "notificationServiceBaseUrl": "https://notification.asbar.uk",
      "awsUrl": "https://asbar-oss-dev-01.oss-me-central-1.aliyuncs.com/",
      "mapKey": "AIzaSyDt-3iS_kTNAHFiFi32b2dSRU8NzlaWR8g",
      "moyassarPublishableKey": "pk_test_UD2aikfikR8nXZhcynGrBjDZ63dw3Lpcvb9Fwtpi",
      "menuStyle": "side-menu",
      "footerStyle": "simple",
      "showWelcomeMessageInAuthScreens": false,
      "showInvestTypesBeforeRegistration": true,
      "opportunityTheme": "modern",
      "opportunityDetailsTheme": "modern",
      "profileSettingsTheme": "modern",
      "dialogsTheme": "aside",
      "hasLandingPage": false,
      "googlePlayDownloadUrl": "",
      "appleStoreDownloadUrl": "",
      "twitterUrl": "https://x.com/AsbarCapital",
      "linkedinUrl": "https://www.linkedin.com/in/asbar-capital-ab9660380/",
      "supportEmail": "complaints@asbarcapital.com",
      "tollFreeNumber": "800 244 0445",
      "isOnlinePaymentEnabled": false,
      "isArabBankTransferEnabled": true,
    },
    "mulkia": {
      "primaryColor": "#88B392",
      "lightPrimaryColor": "#b3cab8",
      "mediumPrimaryColor": "#88B392",
      "secondaryColor": "#CFA257",
      "successColor": "#88B392",
      "errorColor": "#EE2C24",
      "warningColor": "#FF9800",
      "infoColor": "#2196F3",
      "coloredLogoUrl": "assets/images/mulkia/logo.svg",
      "whiteLogoUrl": "assets/images/mulkia/logo-white.svg",
      "sidePageImageUrl": "assets/images/mulkia/page-side-img.svg",
      "defaultOpportunityImageUrl": "assets/images/mulkia/opportunity-image.png",
      "homeMobileAppSplashImageUrl": "assets/images/mulkia/mobile-app-splash.png",
      "tenantId": "mulkia",
      "tenantName": "Mulkia",
      "apisBaseUrl": "https://gateway.mulkia.dev",
      "notificationServiceBaseUrl": "https://notification.mulkia.dev",
      "awsUrl": "https://janafinancialqa.oss-me-central-1.aliyuncs.com/",
      "mapKey": "AIzaSyDt-3iS_kTNAHFiFi32b2dSRU8NzlaWR8g",
      "moyassarPublishableKey": "pk_test_UD2aikfikR8nXZhcynGrBjDZ63dw3Lpcvb9Fwtpi",
      "menuStyle": "top-menu",
      "footerStyle": "detailed",
      "showWelcomeMessageInAuthScreens": true,
      "showInvestTypesBeforeRegistration": true,
      "opportunityTheme": "classic",
      "opportunityDetailsTheme": "classic",
      "profileSettingsTheme": "classic",
      "dialogsTheme": "modal",
      "hasLandingPage": true,
      "googlePlayDownloadUrl": "https://play.google.com/store/apps/details?id=com.jariSolution.mulkia&pcampaignid=web_share",
      "appleStoreDownloadUrl": "https://apps.apple.com/eg/app/mulkia-%D9%85%D9%84%D9%83%D9%8A%D8%A9/id6504875734",
      "twitterUrl": "https://x.com/Mulkia_SA?t=6oCHbjkO4PJU67a9YrF42A&s=09%27;",
      "linkedinUrl": "https://www.linkedin.com/company/mulkia/';",
      "supportEmail": "info@mulkia.com.sa",
      "isOnlinePaymentEnabled": false,
      "isArabBankTransferEnabled": false,
    },
    "valueCapital": {
      "primaryColor": "#705a9e",
      "lightPrimaryColor": "#b9abd6",
      "mediumPrimaryColor": "#705a9e",
      "secondaryColor": "#E8E8E9",
      "successColor": "#705a9e",
      "errorColor": "#EE2C24",
      "warningColor": "#FF9800",
      "infoColor": "#2196F3",
      "coloredLogoUrl": "assets/images/valueCapital/logo.svg",
      "whiteLogoUrl": "assets/images/valueCapital/logo-white.svg",
      "sidePageImageUrl": "assets/images/valueCapital/page-side-img.svg",
      "defaultOpportunityImageUrl": "assets/images/valueCapital/opportunity-image.png",
      "homeMobileAppSplashImageUrl": "assets/images/valueCapital/mobile-app-splash.png",
      "tenantId": "valueCapital",
      "tenantName": "Value Capital",
      "apisBaseUrl": "https://gateway.valuecapital.dev",
      "notificationServiceBaseUrl": "https://notification.valuecapital.dev",
      "awsUrl": "https://janafinancialqa.oss-me-central-1.aliyuncs.com/",
      "mapKey": "AIzaSyDt-3iS_kTNAHFiFi32b2dSRU8NzlaWR8g",
      "moyassarPublishableKey": "pk_test_UD2aikfikR8nXZhcynGrBjDZ63dw3Lpcvb9Fwtpi",
      "menuStyle": "top-menu",
      "footerStyle": "detailed",
      "showWelcomeMessageInAuthScreens": true,
      "showInvestTypesBeforeRegistration": true,
      "opportunityTheme": "classic",
      "opportunityDetailsTheme": "classic",
      "profileSettingsTheme": "classic",
      "dialogsTheme": "modal",
      "hasLandingPage": true,
      "googlePlayDownloadUrl": "https://play.google.com/store/apps/details?id=com.jariSolution.valueCapital",
      "appleStoreDownloadUrl": "https://apps.apple.com/app/value-capital-%D9%82%D9%8A%D9%85%D8%A9-%D8%A7%D9%84%D9%85%D8%A7%D9%84%D9%8A%D8%A9/id6740330545",
      "twitterUrl": "https://x.com/ValueCapitalKSA",
      "linkedinUrl": "https://www.linkedin.com/company/value-capital-sa/",
      "supportEmail": "CRM@valuecapital.sa",
      "isOnlinePaymentEnabled": false,
      "isArabBankTransferEnabled": false,
    }
  }
};

